import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage'
import Aside from '@/components/Aside'
import ProductList from '@/components/ProductList'
import HotNews from '@/components/HotNews'
import ContactUs from '@/components/ContactUs'
import Top from '@/components/Top'
import Footer from '@/components/Footer'
import Navigition from '@/components/Navigition'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/Aside',
      name: 'Aside',
      component: Aside
    },
    {
      path: '/ProductList',
      name: 'ProductList',
      component: ProductList
    }
    ,
    {
      path: '/HotNews',
      name: 'HotNews',
      component: HotNews
    }
    ,
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    }
    ,
    {
      path: '/Top',
      name: 'Top',
      component: Top
    },
    {
      path: '/Footer',
      name: 'Footer',
      component: Footer
    },
    {
      path: '/Navigition',
      name: 'Navigition',
      component: Navigition
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js